module.exports = __webpack_public_path__ + "static/media/sologo.b85164b0.png";